module.exports = __webpack_public_path__ + "img/guidedMentorship.c33ac4df.svg";